<script lang="ts">
  import { Button, Col, Container, Row } from "sveltestrap";
  import BookmarkInvoice from "./BookmarkInvoice.svelte";
  import Card from "../../../Core/Card.svelte";
  import { Cancel, Print } from "../../../../utils/Constant/Constant";
  import InvoiceHeader from "./InvoiceHeader.svelte";
  import ItemDescription from "./ItemDescription.svelte";
  import InvoiceProfile from "./InvoiceProfile.svelte";
 
</script>
<BookmarkInvoice />
<Container class="invoice">
  <Row>
    <Col sm="12">
      <Card>
        <div slot="contentbody">
          <div>
            <div>
              <InvoiceHeader />
              <InvoiceProfile />
              <ItemDescription />
            </div>
            <Col sm="12" class="text-center mt-3">
              <Button color="primary" class="me-2" >{Print}</Button>
              <Button color="secondary" href="/ecommerce/product">{Cancel}</Button>
            </Col>
          </div>
        </div>
      </Card>
    </Col>
  </Row>
</Container>